
import Vue, { PropType } from 'vue';
import { Assessment } from '@/models/assessment.model';
import { Icon, Modal } from '@descomplica/vue-components';
import { validateLink } from '@/helpers/validators';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { PostgradEarlyGraduationTrackingInformation } from '@/models/postgradEarlyGraduation/PostgradEarlyGraduationModel';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

export default Vue.extend({
  components: {
    Icon,
    Modal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    assessment: {
      type: Object as PropType<Assessment>,
      required: true,
    },
  },
  data() {
    return {
      pitchLink: '',
      isValidLink: false,
      isActive: this.active,
      showLinkErrorMessage: false,
      showSendErrorMessage: false,
    };
  },
  computed: {
    borderRadius(): number {
      return this.getBorderRadius(window.innerWidth);
    },
    currentChimeraCourse(): ChimeraCourseModel | null {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    earlyGraduationTrackingProps(): PostgradEarlyGraduationTrackingInformation {
      return this.$store.getters.earlyGraduationTrackings(this.currentChimeraCourse);
    },
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
  },
  methods: {
    getBorderRadius(width: number): number {
      if (width > 495) return 24;
      return 0;
    },
    updateActive(active: boolean) {
      this.$emit('update:active', active);
    },
    onCloseClick() {
      this.updateActive(false);
    },
    validateUrl() {
      this.showSendErrorMessage = false;
      this.isValidLink = validateLink(this.pitchLink);

      if (this.isValidLink) this.showLinkErrorMessage = false;
    },
    shouldShowErrorOnBlur() {
      this.showLinkErrorMessage = this.pitchLink === '' ? false : !this.isValidLink;
    },

    async sendAssessmentReply() {
      if (this.isValidLink) {
        this.showSendErrorMessage = false;
        const dexCourseId = this.$store.getters.currentCourse.id;

        const replyData = {
          dexCourseId,
          data: {
            fileLink: this.pitchLink,
            assessmentId: this.assessment.id,
          },
        };

        try {
          await this.$store.dispatch('SEND_ASSESSMENT_REPLY_FILE', replyData);
          this.onCloseClick();
        } catch (error) {
          this.showSendErrorMessage = true;
        }

        if (!this.showSendErrorMessage) {
          this.$store.dispatch('PULL_MINIMUM_ASSESSMENT_DATA', { dexCourseId });
          Analytics.trackEvent(EVENT_LABELS.pitchSent, {
            relatedAssessmentCategory: this.assessment.category?.name || '',
            ...this.earlyGraduationTrackingProps,
          });
        }
      }
    },
  },
});
